import { ProducerUserTypesEnumSchema } from '@eigtech/auth0-types';
import { z } from 'zod';
import { PortalEntityTypeSchema } from '../../base/portal.js';
import { PortalUserSchema } from '../../base/user.js';
import { PortalZoneSchema } from '../../base/zones.js';
export const CreatePortalUserRequestBodySchema = z.object({
    auth0Id: z.string().optional(),
    email: z.string().email(),
    entityPermissions: z.string().array(),
    entityType: PortalEntityTypeSchema,
    externalUserId: z.string(),
    name: z.string(),
    phoneNumber: z.string().optional(),
    requestActor: z.string(),
    userType: ProducerUserTypesEnumSchema,
    zone: PortalZoneSchema,
});
export const CreatePortalUserRequestSchema = CreatePortalUserRequestBodySchema;
export const CreatePortalUserResponseSchema = z.object({ user: PortalUserSchema.or(z.null()) });
export const CreatePortalUserApiSchema = {
    body: CreatePortalUserRequestBodySchema,
    response: CreatePortalUserResponseSchema,
};
